import React, { Component } from 'react'

import storage from 'utils/storage'
import PropTypes from 'prop-types'
import { branch } from 'baobab-react/higher-order'
import isDOMAvailable from 'utils/isDOMAvailable'

class AuthenticatedLink extends Component {
  static propTypes = {
    children: PropTypes.node,
    href: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
    linkProps: PropTypes.object,
    successUrl: PropTypes.string,
  }

  static defaultProps = {
    className: '',
    href: '/',
    onClick: () => {},
  }

  constructor(props) {
    super(props)
    this.state = {
      successUrl: null,
    }
    this.handleClick = this.handleClick.bind(this)
  }

  componentDidMount() {
    isDOMAvailable && this.setState({
      successUrl: window.location.pathname,
    })
  }

  successUrl() {
    return this.props.successUrl || this.state.successUrl || '/'
  }

  handleClick(e) {
    const { currentUser, onClick } = this.props

    // if user NOT logged in show login modal
    if (!currentUser) {
      e.preventDefault()
      window.location.href = `/signin?successUrl=${encodeURIComponent(this.successUrl())}`
    } else if (!currentUser.agreed_to_campus_terms) {
      e.preventDefault()
      storage.set('vpMetaNotice', true)
    } else if (!currentUser.vp_meta || (currentUser.vp_meta && currentUser.grade_level === 'over_g12' && currentUser.has_chosen_college === null)) {
      e.preventDefault()
      // if user ALREADY logged but SCHOOL detail is empty show vp meta notice
      window.location.href = `/signup/application?successUrl=${encodeURIComponent(this.successUrl())}`
    } else {
      // run as usual
      onClick && onClick()
    }
  }

  render() {
    const {
      href,
      children,
      className,
      linkProps,
      dataTestId,
    } = this.props

    return (
      <a href={href} onClick={this.handleClick} className={className} data-testid={dataTestId} {...linkProps}>
        {children}
      </a>
    )
  }
}

export { AuthenticatedLink }
export default branch({
  currentUser: ['serverProps', 'currentUser'],
}, AuthenticatedLink)
